/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

export const getLocalUrl = (): string => {
	return `${process.env.HOSTNAME ? `http://${process.env.HOSTNAME}:3000` : process.env.NEXT_PUBLIC_EPIC_SERVER_URL}`;
};
